import { useSelector, useDispatch, TypedUseSelectorHook } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../reducers';

import { Actions as PageActions } from './page';
import { Actions as SearchActions } from './search';
import { Actions as ArticleFeedbackActions } from './articleFeedback';

// This is a union of all possible action types in our system.
export type Actions = PageActions | SearchActions | ArticleFeedbackActions;

const useTypedSelector: TypedUseSelectorHook<IState> = useSelector;

export interface TypedUseDispatchHook {
  (): Dispatch<Actions>;
}
const useTypedDispatch: TypedUseDispatchHook = useDispatch;

export { useTypedDispatch as useDispatch, useTypedSelector as useSelector };
